import { Expose } from 'class-transformer'

export enum GameTag {
  pregame = 'pregame',
  readytoplay = 'readytoplay',
  playing = 'playing',
  sleep = 'sleeping',
  reset = 'reset',
  paused = 'paused',
  finished = 'finished'
}

export class GameState {
  constructor(
    private _tag = GameTag.pregame,
    private _description = ''
  ) {}
  @Expose()
  public get tag() {
    return this._tag
  }

  public set tag(value) {
    this._tag = value
  }

  @Expose()
  public get description() {
    return this._description
  }

  public set description(value) {
    this._description = value
  }
}
